<template>
  <!-- TODO: Доделать уведомления на пунктах -->
  <div class="sidebar">
    <ul class="nav-list">
      <li>
        <a class="link-unhoverable">
          <i class="bx bx-user"></i>
          <span class="links_name">ваш ID: {{ this.currentUser.id }}</span>
        </a>
        <span class="tooltip">Ваш ID: {{ this.currentUser.id }}</span>
      </li>
      <li v-if="canSeeOrders">
        <router-link to="/orders">
          <i class="bx bx-shopping-bag"></i>
          <span class="links_name">Поставки</span>
        </router-link>
        <span class="tooltip">Поставки</span>
      </li>
      <li v-if="canSeeFinance">
        <router-link to="/finance">
          <i class="bx bx-dollar-circle"></i>
          <span class="links_name">Финансы</span>
        </router-link>
        <span class="tooltip">Финансы</span>
      </li>
    </ul>
    <div class="tsoft-active-section">
      <span>{{ handlerActivePageName() }}</span>
    </div>
    <div class="tsoft-sidebar-button">
      <i class="bx bx-menu" id="btn" @click="handlerOpenOrCloseMenu"></i>
    </div>
    <div class="app-version" v-if="visible">
      <span class="version-text">Версия: {{ appVersion }}</span>
    </div>
  </div>
</template>

<script>
import { API_USERS_LISTS } from "@/constants";
import { mapGetters } from "vuex";

const SERVICES_ID_TO_NAMES = {
  22: "to",
  23: "teo",
  24: "sertifikaciya",
  25: "other",
  75: "pnk", 
  76: "svh", 
  77: "strahovanie"
};
const initialNotifications = () => ({
  orders: [],
  to: [],
  teo: [],
  sertifikaciya: [],
  other: [],
  by_creators: {},
});

export default {
  data() {
    return {
      notificationsLocal: initialNotifications(),
      handlerSidebar: false,
      visible: false,
      internalUsers: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUser", "isAuthenticated"]),

    notifications() {
      return this.$store.getters.NOTIFICATIONS;
    },

    appVersion() {
      return window.CLIENT_VERSION || '0.9.112';
    },

    canSeeOrders() {
      return !this.currentUser.role.includes("sales-manager");
    },

    // уточнить
    canSeeFinance() {
      // return (!this.currentUser.role.includes("client") && !this.currentUser.role.includes("sales-manager"));
      return !this.currentUser.role.includes("sales-manager");
    },
  },
  mounted() {
    this.onlyForAccountant();
    this.$store.dispatch("GET_NOTIFICATIONS");
    setInterval(() => {
      if (this.isAuthenticated) {
        this.$store.dispatch("GET_NOTIFICATIONS");
      }
    }, 30000);

    if (
      this.$store.state.userLocalSettings.interfaceSettings.sidebarMenu ==
      "open"
    ) {
      setTimeout(() => {
        this.handlerOpenOrCloseMenu();
      }, 500);
    }
  },
  watch: {
    notifications(newNotifications) {
      this.distributeNotifications(newNotifications);
    },

    visible(value) {
      this.$store.dispatch("userLocalSettings/SET_INTERFACE_SETTINGS", {
        name: "sidebarMenu",
        value: value ? "open" : "",
      });
    },
  },
  methods: {
    handlerOpenOrCloseMenu() {
      let sidebar = document.querySelector(".sidebar");
      let closeBtn = document.querySelector("#btn");
      let activeSection = document.querySelector(".tsoft-active-section");

      let menuBtnChange = () => {
        if (sidebar.classList.contains("open")) {
          this.visible = true;
          closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
        } else {
          this.visible = false;
          closeBtn.classList.replace("bx-menu-alt-right", "bx-menu");
        }
      };

      activeSection.classList.toggle("hide");
      sidebar.classList.toggle("open");

      menuBtnChange();
    },
    handlerActivePageName() {
      if (this.$route.meta.title) {
        if (this.$route.meta.title == 'Заказы') {
          return "Поставки";
        }
        return this.$route.meta.title;
      }

      if (this.$route.meta.services) {
        return this.$route.meta.services[this.$route.params.service_id];
      }

      if (this.$route.meta.invoices_type) {
        for (let typeInvoices in this.$route.params) {
          return this.$route.meta.invoices_type[
            this.$route.params[typeInvoices]
          ];
        }
      }

      for (let userId in this.internalUsers) {
        if (this.$route.params.user_id == this.internalUsers[userId].id) {
          return "Запросы: " + this.internalUsers[userId].name;
        }
      }
    },
    distributeNotifications(newNotifications = []) {
      this.notificationsLocal = initialNotifications();

      this.internalUsers.forEach((user, index) => {
        this.$set(this.notificationsLocal.by_creators, `${user.id}`, []);
      });

      newNotifications.forEach((notify) => {
        try {
          if (notify.data && notify.data.parameters && notify.data.parameters.service_id) {
            this.notificationsLocal[
              SERVICES_ID_TO_NAMES[notify.data.parameters.service_id]
            ].push(notify);
          }
          if (notify.data && notify.data.parameters && notify.data.parameters.order_id) {
            this.notificationsLocal["orders"].push(notify);
          }
          if (
            this.internalUsers &&
            this.internalUsers.length > 0 &&
            notify.data.parameters &&
            notify.data.parameters.creator_user_id
          ) {
            let user_id = notify.data.parameters.creator_user_id;
            if (this.notificationsLocal.by_creators[user_id]) {
              this.notificationsLocal.by_creators[user_id].push(notify);
            }
          }
        } catch (error) {
          // console.error(error)
        }
      });
    },

    onlyForAccountant() {
      if (
        this.currentUser.role.includes("administrator") ||
        this.currentUser.role.includes("head-accountant") ||
        this.currentUser.role.includes("accountant")
      ) {
        this.getAllFinanceUsers();
        return true;
      }
      return false;
    },

    getAllFinanceUsers() {
      api
        .call("get", `${API_USERS_LISTS}?list_type=for-accountants`)
        .then(({ data }) => {
          this.internalUsers = data;
          this.$store.dispatch("GET_NOTIFICATIONS");
        });
    },
  },
};
</script>
